import { useEffect } from 'react'
import { trackInternalEvent } from '@rio/tracking'

import { WidgetTheme } from '../../WidgetTheme'
import { WidgetProps } from '../../widget.types'
import { useThemeConfig } from '../../hooks/useThemeConfig'
import { WidgetBox, WidgetContainer } from '../../widget.styles'
import { InfoBox, SuccessBox } from '../..'
import { IlustrationBox } from './IlustrationBox'

import { useResumeDistributionConfig } from './hooks/useResumeDistributionConfig'
import { useResumeDistributionActions } from './hooks/useResumeDistributionActions'

export const ResumeDistribution = ({ service, categoryId }: WidgetProps) => {
  const theme = useThemeConfig({ service })
  const { text, status, recruitersCount } = useResumeDistributionConfig(
    service,
    categoryId as string,
  )
  const { handleInitialClick, handleInProgressClick, handleCompletedClick } =
    useResumeDistributionActions({ service })

  const isCompleted = status === 'completed'

  const handleClick = () => {
    trackInternalEvent('progress_cta_click', {
      score: service.title,
      cta: text.actionText,
    })
    if (isCompleted) return handleCompletedClick(categoryId as string)
    if (status === 'progress') return handleInProgressClick()
    return handleInitialClick()
  }

  useEffect(() => {
    if (isCompleted) {
      trackInternalEvent('progress_score_completed', { score: service.title })
    }
  }, [isCompleted, service.title])

  return (
    <WidgetTheme tipOrder={service.widgetTipOrder} theme={theme[status]}>
      <WidgetContainer>
        <WidgetBox>
          <InfoBox
            text={text}
            isCompleted={isCompleted}
            handleClick={handleClick}
            data-testid={`resume-distribution-info-${status}`}
            actionButtonTestId={`resume-distribution-action-button-${status}`}
          />
        </WidgetBox>
        <WidgetBox>
          {isCompleted ? (
            <SuccessBox />
          ) : (
            <IlustrationBox
              status={status}
              recruitersCount={recruitersCount}
              recruitersText={text.recruiters}
            />
          )}
        </WidgetBox>
      </WidgetContainer>
    </WidgetTheme>
  )
}
